import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { studentAPI } from '../services/api';

export const useStudents = () => {
  return useQuery({
    queryKey: ['students'],
    queryFn: () => studentAPI.getAll().then(res => res.data),
  });
};

export const useStudent = (id) => {
  return useQuery({
    queryKey: ['students', id],
    queryFn: () => studentAPI.getById(id).then(res => res.data),
    enabled: !!id,
  });
};

export const useCreateStudent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: studentAPI.create,
    onSuccess: () => {
      queryClient.invalidateQueries(['students']);
    },
  });
};

export const useDeactivateStudent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => studentAPI.deactivate(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['students']);
    },
  });
};

export const useActivateStudent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => studentAPI.activate(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['students']);
    },
  });
};